module.exports = __webpack_public_path__ + "static/media/THSarabunNew Bold.4a12003b.ttf";